<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <div class="button-container">
          <el-button
            :disabled="isLoading"
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="handleCreate"
          >
            {{ $t('button.create') }}
          </el-button>
        </div>
      </div>
    </template>
    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
      style="width: 100%"
      row-key="id"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="50"
      /> -->
      <el-table-column
        prop="country"
        label="Country"
        width="100"
      />
      <el-table-column
        prop="locale"
        label="Locale"
        width="100"
      />
      <el-table-column
        prop="title"
        label="Title"
      />
      <el-table-column
        label="Action"
        align="center"
        width="120"
      >
        <template slot-scope="{ row, $index }">
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(row)"
          />
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDelete(row)"
          />
        </template>
      </el-table-column>
    </el-table>
    
  </sticky-header-layout>
</template>

<script>
import HomeConfigsAPI from '../../api/home-configs'

export default {
  name: 'HelloBarList',
  data() {
    return {
      list: [],
      isLoading: true,
    }
  },
  computed: {
    canSave() {
      return !this.loading
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await HomeConfigsAPI.getHelloBarList()
        const { data } = response
        // const { rows } = data
        if (Array.isArray(data)) {
          this.list = data
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    handleCreate() {
      this.$router.push({ path: `/home-configs/hello-bars/create` })
    },
    handleUpdate(row) {
      this.$router.push({ path: `/home-configs/hello-bars/${row.id}` })
    },
    handleDelete(row) {
      this.$confirm(`Confirm Delete?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.deleteHelloBar(row.id)
      }).catch(() => {
      })
    },
    async deleteHelloBar(id) {
      this.isLoading = true
      try {
        const result = await HomeConfigsAPI.deleteHelloBar(id)
        this.getList()
      } catch (error) {
        this.isLoading = false
        this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
          type: 'error',
          confirmButtonText: 'OK',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>

